import { cn } from "@theprelude/core";
import { useId } from "react";

export const AbnormalSecurityIcon: React.FC<
  React.ComponentPropsWithoutRef<"svg">
> = ({ className, ...props }) => {
  const clipPathId = useId();

  return (
    <svg
      className={cn("size-4 flex-shrink-0", className)}
      {...props}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M10.8458 0L15.9442 15.9394H13.0768L7.97084 0H10.8433H10.8458ZM0 15.9394H2.86991L7.97338 0H5.0984L0 15.9394Z" />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
